<div class="row align-items-center">
    <div class="col">
        <app-breadcrumb></app-breadcrumb>
    </div>
    <div class="col-auto">
        <select class="form-control form-control-sm"
            [(ngModel)]="selectedYear"
            (ngModelChange)="changeYear($event)">
            <option *ngFor="let item of listYear;" [ngValue]="item">{{item}} 년</option>
        </select>
    </div>
    <div class="col-auto">
        <select class="form-control form-control-sm"
            [(ngModel)]="selectedMonth"
            (ngModelChange)="changeMonth($event)">
            <option *ngFor="let item of listMonth;" [ngValue]="item">{{item}} 월</option>
        </select>
    </div>
</div>

<div class="card-deck">
    <div class="card mb-0 border shadow-sm">
        <div class="card-header bg-white">
            <div class="h5 font-weight-normal mb-0">
                <i class="mdi mdi-file"></i>
                <span class="ml-1">
                    운행 시간
                </span>
            </div>
        </div>
        <div class="card-body pt-0 pb-2 d-flex align-items-end">
            <div id="chart-01" class="w-100" style="height:150px;"></div>
        </div>
    </div>

    <div class="card mb-0 border shadow-sm">
        <div class="card-header bg-white">
            <div class="h5 font-weight-normal mb-0">
                <i class="mdi mdi-file"></i>
                <span class="ml-1">
                    운행 거리
                </span>
            </div>
        </div>
        <div class="card-body pt-0 pb-2 d-flex align-items-end">
            <div id="chart-02" class="w-100" style="height:150px;"></div>
        </div>
    </div>
</div>

<div class="card mb-0 mt-3">
    <div class="card-header bg-white">
        <div class="row">
            <div class="col">
                <div class="h5 font-weight-normal mb-0">
                    <i class="mdi mdi-file"></i>
                    <span class="ml-1">
                        일별 운행 일지
                    </span>
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-outline-success"
                    (click)="exportExcel()">
                    <i class="fas fa-file-excel"></i>
                    <span class="ml-1">엑셀출력</span>
                </button>
            </div>
        </div>
    </div>
    <div class="card-body mt-0">
        <div class="table-responsive">
            <table class="table table-sm table-hover align-items-center mb-0">
                <thead>
                    <tr class="text-center">
                        <th>
                            운행일시
                        </th>
                        <th>
                            운행시간
                        </th>
                        <th>
                            운행거리(km)
                        </th>
                        <th>
                            트립건수
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-center" *ngFor="let item of listItem;let idx = index;">
                        <td>
                            {{item.dtgRegDtFromK}}
                        </td>
                        <td>
                            {{item.dtgRegDtDurationK}}
                        </td>
                        <td>
                            {{item.dtgDistAccumulK}}
                        </td>
                        <td>
                            {{item.dtgDriveTripCnt}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>